"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isFutureSubscription = (date) => new Date(date).getTime() > Date.now();
exports.default = (acc, current) => {
    if (isFutureSubscription(current.start)) {
        return {
            ...current,
            ...acc,
            end: current.end,
            duration: acc.duration + current.duration,
        };
    }
    return {
        ...current,
        ...acc,
        end: current.end,
        duration: acc.duration + current.duration,
        coach: current.coach || acc.coach,
        trainingLocation: current.trainingLocation
            ? {
                details: current.trainingLocation.details || acc.trainingLocation.details,
                placeName: current.trainingLocation.placeName ||
                    acc.trainingLocation.placeName,
            }
            : null,
        coachingDays: current.coachingDays || acc.coachingDays,
        subscriptionType: current.subscriptionType,
        plan: current.plan
            ? {
                name: current.plan.name || acc.plan.name,
            }
            : null,
    };
};
//# sourceMappingURL=PeriodToSubscriptionReducer.js.map